<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import { mapGetters, mapActions, mapState } from "vuex";
import moment from "moment";
import axios from "axios";
import DataTable from "@/components/DataTable.vue";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Creditors Report",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    DataTable,
  },
  data() {
    return {
      title: "Credit Purchases Report",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Creditors Report",
          active: true,
        },
      ],
      totalRows: 1,
      filterTitle: "Credit Purchases",
      pageOptions: [10, 25, 50, 100, 200, 1000],
      IsCreditorsServerPaginated: true,
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      filteredReport: [],
      totals: {
        totalAmount: 0,
        totalPaid: 0,
        totalDiscount: 0,
      },
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "details",
          sortable: true,
          label: "PRODUCTS",
        },
        {
          key: "tt_amt",
          sortable: true,
          label: "TOTAL",
        },
        {
          key: "amt_paid",
          sortable: true,
          label: "PAID",
        },
        {
          key: "discount_field",
          sortable: true,
          label: "DISCOUNT",
        },
        {
          key: "Balance",
          sortable: true,
          label: "BALANCE",
        },
        {
          key: "supplier",
          sortable: true,
          label: "SUPPLIER",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
      ],
      data: {
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        supplier: null,
        period: 0,
      },
    };
  },
  
  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("purchase", [
      "SaveStatus",
      "Creditors",
      "FilterStatus",
      "CreditorsPagination",
      "CreditorsPaginated",
      "CreditorsSummary",
    ]),
    ...mapGetters("setting", ["PaymentOptions"]),
    ...mapGetters("auth", ["business", "branch"]),
    ...mapGetters("stock", ["Suppliers"]),

    rows() {
      return this.IsCreditorsServerPaginated
        ? this.CreditorsPagination.total
        : this.Creditors
        ? this.Creditors.length
        : 0;
    },

    perPage: {
      get() {
        if (this.IsCreditorsServerPaginated) {
          return (
            this.CreditorsPagination.per_page ||
            this.data.per_page ||
            this.serverPerPage
          );
        } else {
          return this.serverPerPage;
        }
      },
      set(value) {
        if (this.IsCreditorsServerPaginated) {
          this.data.per_page = value;
          this.data.page = 1;
          this.FetchCreditors(this.data);
        } else {
          this.serverPerPage = value;
        }
      },
    },

    currentPage: {
      get() {
        return this.CreditorsPaginated && this.CreditorsPagination
          ? this.CreditorsPagination.current_page
          : 1;
      },
      set(value) {
        if (this.CreditorsPaginated) {
          this.data.page = value;
          this.handlePageChange(value);
        }
      },
    },
  },

  methods: {
    ...mapActions({
      FetchCreditors: "purchase/fetchCreditors",
      ClearBalance: "purchase/ClearCredit",
      FetchModes: "setting/fetchPaymentOptions",
      FetchSuppliers: "stock/fetchSuppliers",
    }),

    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    CreditorsData() {
      this.filteredReport = this.Creditors;
      let total_amount = 0;
      let total_paid = 0;
      let total_discount = 0;
      this.Creditors.forEach((item) => {
        total_amount = total_amount + parseInt(item.totAmt);
        total_paid = total_paid + parseInt(item.amtPaid);
        total_discount = total_discount + parseInt(item.discount);

        this.totals.totalBalance =
          this.totals.totalAmount -
          (this.totals.totalPaid + this.totals.totalDiscount);
      });
      this.totals.totalPaid = total_paid;
      this.totals.totalAmount = total_amount;
      this.totals.totalDiscount = total_discount;
      this.totals.totalBalance = total_amount - (total_paid + total_discount);
    },
    filterReport() {
      this.FetchCreditors(this.data);
    },

    Excel_export() {
      axios
        .post("export_creditors", this.data, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", "creditors_report.xlsx");
          document.body.appendChild(fileLink);
          fileLink.click();
          this.spinner = false;
        })
        .catch(() => {});
    },

    handlePageChange(newPage) {
      if (this.IsCreditorsServerPaginated) {
        this.data.page = newPage;
        this.FetchCreditors(this.data);
      }
    },
  },

  watch: {
    Creditors(newValue) {
      if (newValue) {
        this.CreditorsData();
      }
    },
  },

  created() {
    this.FetchCreditors(this.data);
    this.CreditorsData();
    this.FetchSuppliers();
  },
};
</script>

<template>
  <Layout>
    <h4 class="text-center text-primary">{{ business }} - {{ branch }}</h4>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div v-if="filterTitle">
                <h4>
                  <center>{{ filterTitle }}</center>
                </h4>
              </div>
              <div class="col-4">
                <b-button variant="info" @click="Excel_export()"
                  ><i class="fa fa-download"></i>Export</b-button
                >
              </div>
            </div>
            <div class="row">
              <div class="col-2">
                <div class="form-group">
                  <label>From</label>
                  <input
                    type="date"
                    v-model="data.datefrom"
                    class="form-control"
                    v-limit-future-date
                  />
                </div>
              </div>
              <div class="col-2">
                <div class="form-group">
                  <label>To</label>
                  <input
                    type="date"
                    v-model="data.dateto"
                    class="form-control"
                    v-limit-future-date
                  />
                </div>
              </div>
              <div class="col-md-4 form-group">
                <label>Supplier</label>

                <model-list-select
                  :list="
                    Suppliers
                      ? [{ id: '', name: 'All Suppliers' }, ...Suppliers]
                      : []
                  "
                  v-model="data.supplier"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Supplier"
                  @input="filterReport()"
                >
                </model-list-select>
              </div>
              <div class="col-md-2 form-group">
                <label>Period</label>
                <select class="form-control" v-model="data.period">
                  <option value="0" selected>Selected</option>
                  <option value="1" selected>All time</option>
                </select>
              </div>
              <div class="col-md-2 mt-4">
                <button
                  class="btn btn-primary"
                  type="button"
                  @click="filterReport()"
                >
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner
                    v-show="FilterStatus"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <DataTable
                :columns="fields"
                :rows="Creditors"
                :total-rows="rows"
                :pagination="CreditorsPagination"
                :server-pagination="IsCreditorsServerPaginated"
                :loading="FilterStatus"
              >
                <template #cell(index)="{ index }">
                  {{ (currentPage - 1) * perPage + index + 1 }}
                </template>
                <template #cell(tt_amt)="{ row }">
                  {{ thousandSeperator(row.totAmt) }}
                </template>
                <template #cell(amt_paid)="{ row }">
                  {{ thousandSeperator(row.amtPaid) }}
                </template>
                <template #cell(discount_field)="{ row }">
                  {{ thousandSeperator(row.discount) }}
                </template>
                <template #cell(Balance)="{ row }">
                  {{ thousandSeperator(row.Balance) }}
                </template>
                <template #cell(details)="{ row }">
                  <p v-for="(det, d) in row.items" :key="d">
                    {{ det.product }},
                  </p>
                </template>
              </DataTable>
              <div class="row">
                <div class="col-md-3">
                  <h5>
                    Total Amount:
                    <span class="text-danger">{{
                      thousandSeperator(totals.totalAmount)
                    }}</span>
                  </h5>
                </div>
                <div class="col-md-3">
                  <h5>
                    Total Paid:
                    <span class="text-danger">{{
                      thousandSeperator(totals.totalPaid)
                    }}</span>
                  </h5>
                </div>
                <div class="col-md-3">
                  <h5>
                    Total Discount:
                    <span class="text-danger">{{
                      thousandSeperator(totals.totalDiscount)
                    }}</span>
                  </h5>
                </div>
                <div class="col-md-3">
                  <h5>
                    Total Balance:
                    <span class="text-danger">{{
                      thousandSeperator(
                        totals.totalAmount -
                          (totals.totalPaid + totals.totalDiscount)
                      )
                    }}</span>
                  </h5>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
</style>
